import { render, staticRenderFns } from "./approval-travel.vue?vue&type=template&id=1902b5ce&scoped=true"
import script from "./approval-travel.vue?vue&type=script&lang=js"
export * from "./approval-travel.vue?vue&type=script&lang=js"
import style0 from "./approval-travel.vue?vue&type=style&index=0&id=1902b5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1902b5ce",
  null
  
)

export default component.exports